import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["onClick", "className", "children"];
import React from 'react';
import { extractDataProps } from "../../../lib/utils";
export var PagingDefaultComponent = function PagingDefaultComponent(_ref) {
  var onClick = _ref.onClick,
      className = _ref.className,
      children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _extractDataProps = extractDataProps(rest),
      dataProps = _extractDataProps.dataProps;

  return /*#__PURE__*/React.createElement("span", _extends({
    onClick: onClick,
    className: className
  }, dataProps), children);
};